import * as R from 'ramda';

import generator from "../../hor/module";
import {createAction} from "redux-act";

const {
  reducer,
  fetch,
  updateSuccess
} = generator({
  name: 'Request',
  tableId: 219,
  parseItem: R.compose(
    R.evolve({
      custom_вопрос: R.defaultTo(''),
      custom_закрыта: R.defaultTo(false),
      ___modifieddate: R.identity,
    }),
    item => R.pipe(
      R.dissoc('___modifieddate'),
      R.assoc('modifiedDate', item.___modifieddate)
    )(item)
  ),
})

export {
  fetch,
  updateSuccess
}

export {
  getRequestSelector,
  getRequestKey,
} from './selectors'

export const saveAnswer = createAction('REQUEST_SET_ANSWER')

export { default as saga } from './saga';

export default reducer;